import React from 'react';
import {localizeFullDate} from "../../../../lib/utils/format";
import {pluralizeWord} from "../../../../lib/utils/helpers";
import {t} from "i18next";

const formatTime = (dateValue) => {
    const date = new Date(dateValue);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
}

const SubscriptionHistoryList = ({ groupedSubscriptions }) => {
    const dotSeparator = ' • ';

    return (
        <div className="history-block__wrap">
            {Object.entries(groupedSubscriptions)
                .sort(([yearA], [yearB]) => yearB - yearA)
                .map(([year, yearSubscriptions]) => (
                    <div key={year}>
                        <div className="history-block__year">{year}</div>
                        {yearSubscriptions.map((subscription, index) => {
                            const {order_id, created_at, comment, value_change} = subscription;
                            const hasEventData = order_id?.product_data?.event_name ||
                                comment ||
                                order_id?.product_data?.base_name;

                            return (
                                <div key={subscription.id || index} className="history-block__item">
                                    <div className="history-block__info">
                                        <div className="history-block__name">
                                            {hasEventData ? (
                                                <>
                                                    {order_id?.product_data?.event_name || comment}
                                                    {order_id?.product_data?.base_name && `, ${order_id.product_data.base_name}`}
                                                </>
                                            ) : (
                                                value_change > 0 ? t('common.replenishment') : t('common.writeOff')
                                            )}
                                        </div>
                                        <div className="history-block__details">
                                            {localizeFullDate(created_at)}
                                            {created_at && (
                                                <>{dotSeparator + formatTime(created_at)}</>
                                            )}
                                            {order_id?.paid_for_length && (
                                                dotSeparator + order_id?.paid_for_length + ' ' + pluralizeWord(t('profile.events.place'), order_id?.paid_for_length)
                                            )}
                                        </div>
                                    </div>
                                    <div className="history-block__price">{value_change} ₽</div>
                                </div>
                            );
                        })}
                    </div>
                ))}
        </div>
    );
};

export default SubscriptionHistoryList;